export const availableEvents = [
    {
        utm_source: 'event',
        utm_medium: 'qrcode',
        utm_campaign: 'lovetomorrow',
    }
];
